module.exports = __webpack_public_path__ + "static/media/lucky.ad24de11.wav";